import Joi from "joi";

export default Joi.object({
  alias: Joi.string().required().messages({
    "string.base": "Alias obbligatorio",
    "string.required": "Alias obbligatorio",
    "string.empty": "Alias obbligatorio",
  }),
  secret_key: Joi.string().required().messages({
    "string.base": "Secret_key obbligatorio",
    "string.required": "Secret_key obbligatorio",
    "string.empty": "Secret_key obbligatorio",
  }),
  name: Joi.string().required().messages({
    "string.base": "Nome obbligatorio",
    "string.required": "Nome obbligatorio",
    "string.empty": "Nome obbligatorio",
  }),
  address: Joi.string().required().messages({
    "string.base": "Indirizzo obbligatorio",
    "string.required": "Indirizzo obbligatorio",
    "string.empty": "Indirizzo obbligatorio",
  }),
  housenumber: Joi.string().required().messages({
    "string.base": "Civico obbligatorio",
    "string.required": "Civico obbligatorio",
    "string.empty": "Civico obbligatorio",
  }),
  city: Joi.string().required().messages({
    "string.base": "Città obbligatorio",
    "string.required": "Città obbligatorio",
    "string.empty": "Città obbligatorio",
  }),
  email: Joi.string().required().messages({
    "string.base": "Email obbligatorio",
    "string.required": "Email obbligatorio",
    "string.empty": "Email obbligatorio",
  }),
  company: Joi.any(),
});
